export default "__VITE_ASSET__b2bcc4bf__"